import { BreadType } from 'types/bread'
import { FirebaseDocRefType, FirebaseTimestamp } from 'firebase/index'
import { ScheduleType } from 'types/schedule'
import { StockType } from 'types/stock'
import { parseTimeToDate, parseToDate, sumCheckoutItemsAmount } from './helper'
import { CheckoutItemType } from 'types/checkoutItem'
import { isBefore } from 'date-fns'

export const addDefaultStock = (
  bread: BreadType,
  storeRef: FirebaseDocRefType,
  schedule: ScheduleType,
  stockRef: FirebaseDocRefType,
  latestOrderStartTime: string,
  lastOrderTime: string,
  storeName: string,
  date: string,
  pickupableTime: string,
  scheduledStock = 0
): StockType => {
  return {
    bread_ref: schedule.bread_ref,
    bread_name: bread.name,
    date: date,
    choices: schedule.choices,
    deadline: FirebaseTimestamp.fromDate(parseTimeToDate(lastOrderTime, parseToDate(date))),
    image_url: bread.image_urls[0] || '',
    last_notified_time: FirebaseTimestamp.fromDate(parseTimeToDate(latestOrderStartTime, parseToDate(date))),
    maximum_order: schedule.maximum_order,
    note: schedule.note,
    options: schedule.options,
    pickupable_time: pickupableTime,
    price: bread.price,
    stock: scheduledStock,
    stock_ref: stockRef,
    store_name: storeName,
    store_ref: storeRef,
    type: 'daily',
  }
}

/**
 * 同じ商品で複数の受渡解禁時刻がある場合、通知すべき在庫データ1つを判定して返す
 * 1. 有効在庫数(オープン時在庫数 - 注文数)が0の場合は通知しない
 * 2. 現在時刻より後の最も近い受渡解禁時刻の在庫を通知
 * 3. 現在時刻より後の商品がない場合、最終の受渡解禁時刻の在庫を通知
 */
export const findNotifiedStock = (
  now: Date,
  stocks: StockType[],
  checkoutItems: CheckoutItemType[]
): StockType | undefined => {
  // 有効在庫数が0以下の場合は通知しない
  const validStocks = stocks.filter((stock) => {
    const validStockAmount = stock.stock - sumCheckoutItemsAmount(checkoutItems, stock.pickupable_time)
    return validStockAmount > 0
  })

  // 現在時刻より後の最も近い受渡解禁時刻の在庫を通知
  const nearestFutureStock = validStocks
    .sort((a, b) => {
      return a.pickupable_time < b.pickupable_time ? -1 : 1
    })
    .find((stock) => {
      const pickupableDateTime = parseTimeToDate(stock.pickupable_time)
      return isBefore(now, pickupableDateTime)
    })
  if (nearestFutureStock) return nearestFutureStock

  // 現在時刻より後の商品がない場合、最終の受渡解禁時刻の在庫を通知
  return validStocks
    .sort((a, b) => {
      return a.pickupable_time > b.pickupable_time ? -1 : 1
    })
    .find((stock) => {
      const pickupableDateTime = parseTimeToDate(stock.pickupable_time)
      return isBefore(pickupableDateTime, now)
    })
}
